import React from "react";
import { array, object, number, string } from "prop-types";
import { Table } from "reactstrap";
import {
  MONITORING_QUEUE_ENTRY_TYPES,
  typeOptions,
} from "../../../constants/monitoringQueueEntryConstants";

const MonitoringQueueEntryClientDetailsTable = ({
  inputParams,
  client,
  mqType,
  url,
}) => {
  const type = inputParams.find((x) => x.name === "Type");
  const firstName = inputParams.find((x) => x.name === "FirstName");
  const middleName = inputParams.find((x) => x.name === "MiddleName");
  const lastName = inputParams.find((x) => x.name === "LastName");
  const fullName = inputParams.find((x) => x.name === "FullName");
  const clientName = inputParams.find((x) => x.name === "Client");
  const egnUcn = inputParams.find((x) => x.name === "EGN_UCN");
  const matchPercent = inputParams.find((x) => x.name === "Match Percent");
  const matchPercentNoPEP = inputParams.find(
    (x) => x.name === "Negative Info List Percent",
  );
  const matchPercentPEP = inputParams.find(
    (x) => x.name === "PEP Match Percent",
  );
  const watchListTypes = inputParams.find((x) => x.name === "Watch List Types");
  const categoryTypeList = inputParams.find((x) => x.categoryTypeList);

  let name = "";
  let inputType = "";

  if (fullName) {
    name = fullName.value;
  } else if (clientName) {
    name = clientName.value;
  } else if (!fullName && !clientName) {
    const nameArr = [];
    if (firstName) {
      nameArr.push(firstName.value);
    }
    if (middleName) {
      nameArr.push(middleName.value);
    }
    if (lastName) {
      nameArr.push(lastName.value);
    }
    name = nameArr.join(" ");
  }

  if (type) {
    inputType = type.value;
  } else if (client) {
    inputType = client.type;
  }

  const CategoryTypeListWRS = () => (
    <tr>
      <td align="right" className="w-50">
        <b>Watchlist Searches</b>
      </td>
      <td>{categoryTypeList.categoryTypeList.join(", ")}</td>
    </tr>
  );

  const MatchPercentTR = () => (
    <tr>
      <td align="right" className="w-50">
        <b>Match Percent</b>
      </td>
      <td>{matchPercent.value}</td>
    </tr>
  );

  const MatchPercentNoPEPTR = () => (
    <tr>
      <td align="right" className="w-50">
        <b>{matchPercentNoPEP.name}</b>
      </td>
      <td>{matchPercentNoPEP.value}</td>
    </tr>
  );

  const MatchPercentPEPTR = () => (
    <tr>
      <td align="right" className="w-50">
        <b>{matchPercentPEP.name}</b>
      </td>
      <td>{matchPercentPEP.value}</td>
    </tr>
  );

  const WatchListTypesTR = () => (
    <tr>
      <td align="right" className="w-50">
        <b>Watchlist Types</b>
      </td>
      <td>{watchListTypes.value}</td>
    </tr>
  );

  return (
    <React.Fragment>
      <Table className="monitoring-queue-entry-client-details-table">
        <thead className="thead-light">
          <tr>
            <th colSpan="2" className="center">
              <b>
                Input Parameters -
                {typeOptions.find((x) => x.value === mqType).label}
              </b>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td align="right" className="w-50">
              <b>Type</b>
            </td>
            <td>{inputType}</td>
          </tr>
          <tr>
            <td align="right" className="w-50">
              <b>Name</b>
            </td>
            <td>{name}</td>
          </tr>
          {matchPercent ? <MatchPercentTR /> : null}
          {matchPercentNoPEP ? <MatchPercentNoPEPTR /> : null}
          {matchPercentPEP ? <MatchPercentPEPTR /> : null}
          {watchListTypes ? <WatchListTypesTR /> : null}
          {mqType !== MONITORING_QUEUE_ENTRY_TYPES.WATCHLIST_MANUAL_SEARCH && (
            <React.Fragment>
              <tr>
                <td align="right" className="w-50">
                  <b>EGN</b>
                </td>
                <td>{egnUcn ? egnUcn.value : ""}</td>
              </tr>
              <tr>
                <td align="right" className="w-50">
                  <b>Offer ID</b>
                </td>
                <td>{client ? client.offerId : ""}</td>
              </tr>
            </React.Fragment>
          )}
          {url &&
            mqType !== MONITORING_QUEUE_ENTRY_TYPES.NEGATIVE_MEDIA_INFO && (
              <tr>
                <td align="right" className="w-50">
                  <b>URL</b>
                </td>
                <td>
                  <a target="_blank" href={url}>
                    {
                      url.match(
                        /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\n?=]+)/im,
                      )[1]
                    }
                  </a>
                </td>
              </tr>
            )}
          {categoryTypeList &&
          categoryTypeList.categoryTypeList &&
          categoryTypeList.categoryTypeList.length ? (
            <CategoryTypeListWRS />
          ) : null}
        </tbody>
      </Table>
      <br />
      <br />
    </React.Fragment>
  );
};

MonitoringQueueEntryClientDetailsTable.propTypes = {
  inputParams: array.isRequired,
  client: object,
  mqType: number,
  url: string,
};

export default MonitoringQueueEntryClientDetailsTable;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/client/client-details-table/MonitoringQueueEntryClientDetailsTable.jsx